import Vue from 'vue'
import PhaseOperationsOption from './phaseOperations.vue'

const PhaseOperations = Vue.extend(PhaseOperationsOption)

export function templatePhaseOperationsVue({ module }) {
  const phaseOperations = new PhaseOperations({
    propsData: {
      module
    }
  }).$mount()
  return phaseOperations.$el
}
